import type { TranslationDictionary } from '../types';

export const hi: TranslationDictionary = {
  common: {
    appName: 'ApnaBlock',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    create: 'बनाएं',
    back: 'वापस',
    search: 'खोजें...',
    filter: 'फ़िल्टर',
    refresh: 'रीफ़्रेश करें',
    submit: 'जमा करें',
    loading: 'लोड हो रहा है...',
    close: 'बंद करें',
    yes: 'हाँ',
    no: 'नहीं',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    open: 'खुला',
    pending: 'लंबित',
    approved: 'स्वीकृत',
    rejected: 'अस्वीकृत',
    completed: 'पूर्ण',
    inProgress: 'प्रगति पर है',
    resolved: 'समाधान हो गया',
    viewDetails: 'विवरण देखें',
    download: 'डाउनलोड करें',
    print: 'प्रिंट करें',
    export: 'निर्यात करें',
    actions: 'क्रियाएं',
    status: 'स्थिति',
    date: 'दिनांक',
    total: 'कुल',
    all: 'सभी',
    reset: 'रीसेट करें',
    more: 'अधिक',
    select: 'चुनें',
    language: 'भाषा',
    selectLanguage: 'भाषा चुनें',
    saveChanges: 'परिवर्तन सहेजें',
    savedSuccessfully: 'सफलतापूर्वक सहेजा गया',
    confirm: 'पुष्टि करें',
    home: 'होम',
    favorites: 'पसंदीदा',
    pinned: 'पिन किए गए',
    tenant: 'सोसायटी / समुदाय',
    openMenu: 'मेनू खोलें',
    expandMenu: 'मेनू विस्तृत करें',
    minimizeMenu: 'मेनू छोटा करें',
    lightMode: 'लाइट मोड',
    darkMode: 'डार्क मोड',
    accountMenu: 'खाता मेनू',
    commandPalette: 'कमांड पैलेट',
    searchPages: 'पृष्ठ खोजें...',
    favorite: 'पसंदीदा',
    pin: 'पिन करें',
    calendar: 'कैलेंडर',
    inbox: 'इनबॉक्स',
    ledger: 'खाता बही',
    viewAll: 'सभी देखें',
    platformNoSociety: 'प्लेटफ़ॉर्म (कोई सोसायटी नहीं)',
    noSociety: 'कोई सोसायटी नहीं',
    trial: 'ट्रायल',
    expired: 'समाप्त',
    suspended: 'निलंबित',
    emptyTitle: 'यहाँ अभी कुछ नहीं है',
    emptyDescription: 'विवरण और अपडेट यहाँ उपलब्ध होने पर दिखाई देंगे।',
    tryAgain: 'पुनः प्रयास करें',
    somethingWentWrong: 'कुछ गलत हो गया',
    goBack: 'वापस जाएं',
    goToHome: 'होम पर जाएं',
    referenceId: 'संदर्भ आईडी',
    or: 'या',
  },
  auth: {
    login: 'साइन इन करें',
    logout: 'लॉग आउट',
    profile: 'प्रोफ़ाइल',
    email: 'ईमेल पता',
    password: 'पासवर्ड',
    forgotPassword: 'पासवर्ड भूल गए?',
    sendOtp: 'ओटीपी भेजें',
    verifyOtp: 'ओटीपी सत्यापित करें',
    mobile: 'मोबाइल नंबर',
    rememberMe: 'मुझे याद रखें',
    biometricLogin: 'बायोमेट्रिक लॉगिन',
    changePassword: 'पासवर्ड बदलें',
    signOut: 'साइन आउट',
    welcome: 'स्वागत है',
    signIn: 'साइन इन करें',
    signInSubtitle: 'अपने सोसायटी कार्यक्षेत्र में सुरक्षित रूप से प्रवेश करें।',
    signingInTo: '{{name}} में साइन इन कर रहे हैं',
    method: 'विधि',
    emailTab: 'ईमेल',
    mobileTab: 'मोबाइल',
    otpTab: 'ओटीपी',
    emailLabel: 'ईमेल पता',
    mobileLabel: 'मोबाइल नंबर',
    passwordLabel: 'पासवर्ड',
    enableBiometricAfterLogin: 'साइन इन के बाद बायोमेट्रिक लॉगिन सक्षम करें',
    signInWithBiometrics: 'बायोमेट्रिक्स से साइन इन करें',
    verifyAndSignIn: 'सत्यापित करें और साइन इन करें',
    changeIdentifier: 'पहचान बदलें',
    enterOtpSentTo: 'अपने {{channel}} पर भेजा गया ओटीपी दर्ज करें।',
    otpCodeLabel: 'ओटीपी कोड',
    channelLabel: 'चैनल',
    emailChannel: 'ईमेल',
    smsChannel: 'एसएमएस',
    forgotPasswordTitle: 'पासवर्ड भूल गए',
    forgotPasswordSubtitle: 'अपना ईमेल या मोबाइल दर्ज करें। हम पासवर्ड रीसेट करने के लिए एक ओटीपी भेजेंगे।',
    emailOrMobile: 'ईमेल या मोबाइल नंबर',
    backToSignIn: 'साइन इन पर वापस जाएं',
    resetPasswordTitle: 'पासवर्ड रीसेट करें',
    resetPasswordSubtitle: 'अपने ईमेल या मोबाइल पर भेजा गया ओटीपी दर्ज करें, फिर नया पासवर्ड चुनें।',
    newPasswordLabel: 'नया पासवर्ड',
    confirmPasswordLabel: 'पासवर्ड की पुष्टि करें',
    updatePassword: 'पासवर्ड अपडेट करें',
    changePasswordTitle: 'पासवर्ड बदलें',
    changePasswordSubtitle: 'अपना खाता पासवर्ड अपडेट करें। आप साइन इन रहेंगे।',
    currentPasswordLabel: 'वर्तमान पासवर्ड',
    confirmNewPasswordLabel: 'नए पासवर्ड की पुष्टि करें',
    savePassword: 'पासवर्ड सहेजें',
    passwordRequirementNotice: 'कम से कम 8 वर्णों का उपयोग करें जिसमें बड़े अक्षर, छोटे अक्षर, संख्या और विशेष वर्ण शामिल हों।',
    bannerTagline: 'एंटरप्राइज सोसायटी संचालन — बैंकिंग, वसूली, बैठकें और निवासी एक ही स्थान पर।',
    bannerSubtext: 'कॉलोनियों और हाउसिंग सोसायटियों के लिए सुरक्षित मल्टी-टेनेंट प्लेटफॉर्म।',
    biometricMobileOnly: 'बायोमेट्रिक लॉगिन केवल मोबाइल ऐप पर उपलब्ध है।',
    biometricDesktopInfo: 'बायोमेट्रिक लॉगिन ApnaBlock मोबाइल ऐप में उपलब्ध है।',
    signedInBiometrics: 'बायोमेट्रिक्स से सफलतापूर्वक साइन इन किया गया',
    biometricSessionExpired: 'सत्र समाप्त या रद्द कर दिया गया। कृपया अपने पासवर्ड से साइन इन करें।',
    biometricAuthFailed: 'बायोमेट्रिक प्रमाणीकरण विफल रहा। कृपया पासवर्ड का उपयोग करें।',
    biometricEnrollSuccess: 'बायोमेट्रिक लॉगिन सक्षम किया गया',
    biometricEnrollCancelled: 'बायोमेट्रिक नामांकन रद्द किया गया। सामान्य लॉगिन सफल रहा।',
    welcomeMarketing: 'मार्केटिंग पार्टनर पोर्टल में आपका स्वागत है',
    welcomePlatform: 'प्लेटफॉर्म प्रशासन में आपका स्वागत है',
    welcomeBackToast: 'पुनः स्वागत है',
    otpSentSuccess: 'ओटीपी सफलतापूर्वक भेजा गया',
    otpVerifyFailed: 'ओटीपी सत्यापन विफल रहा',
    loginFailed: 'लॉगिन विफल रहा',
    biometricAuthReason: 'ApnaBlock में साइन इन करने के लिए अपनी पहचान सत्यापित करें',
    biometricAvailableFor: '{{identifier}} के लिए बायोमेट्रिक लॉगिन उपलब्ध है',
    biometricEnrollPrompt: 'क्या {{name}} के लिए बायोमेट्रिक लॉगिन सक्षम करें?',
  },
  nav: {
    dashboard: 'डैशबोर्ड',
    society: 'सोसायटी',
    societySettings: 'मेरी सोसायटी',
    societyBlocks: 'ब्लॉक / टावर',
    societyHouses: 'मकान / फ्लैट',
    societyResidents: 'निवासी',
    societyStaff: 'कर्मचारी',
    imports: 'डेटा आयात',
    finance: 'वित्त और खाते',
    financePayments: 'मेरे भुगतान',
    financeCollections: 'वसूली',
    financeSocietyFund: 'सोसायटी फंड',
    financeSpecialCollections: 'विशेष वसूली',
    financeCorpusFund: 'कॉर्पस फंड',
    financeExpenses: 'खर्चे',
    financeExpenseGroups: 'व्यय समूह',
    financeWaterTanker: 'पानी का टैंकर',
    financeReimbursements: 'प्रतिपूर्ति दावा',
    financeBanking: 'बैंक खाते',
    financeStatements: 'विवरण और रसीदें',
    financeReports: 'वित्तीय रिपोर्ट',
    financeReconciliation: 'भुगतान समाधान',
    security: 'सुरक्षा और गेट',
    gatePasses: 'गेट पास',
    securityDashboard: 'सुरक्षा डैशबोर्ड',
    securityGates: 'गेट प्रबंधन',
    securityShifts: 'चौकीदार शिफ्ट रिपोर्ट',
    securityPolicies: 'सुरक्षा नीतियां',
    securityDeskPortal: 'सुरक्षा गेट डेस्क',
    visitors: 'आगंतुक डेस्क',
    securityCameras: 'सीसीटीवी कैमरे',
    community: 'समुदाय और संचार',
    notices: 'सूचनाएं',
    communityForum: 'सामुदायिक मंच',
    events: 'कार्यक्रम',
    eventsList: 'कार्यक्रम',
    eventsCalendar: 'कार्यक्रम कैलेंडर',
    invitations: 'निमंत्रण और प्रतिक्रिया',
    whatsapp: 'व्हाट्सएप लॉग',
    notifications: 'अधिसूचनाएं',
    operations: 'संचालन और हेल्पडेस्क',
    complaints: 'शिकायतें',
    serviceRequests: 'सेवा अनुरोध',
    serviceDirectory: 'सेवा निर्देशिका',
    amenities: 'सुविधाएं',
    meetings: 'बैठकें',
    documents: 'दस्तावेज़ वॉल्ट',
    governance: 'शासन और चुनाव',
    polls: 'निवासी पोल',
    elections: 'चुनाव',
    governancePetitions: 'याचिका दायर करें',
    governanceResignation: 'इस्तीफा प्रस्तुत करें',
    administration: 'प्रशासन',
    adminLicense: 'लाइसेंस',
    adminInvoices: 'सदस्यता चालान',
    adminRoles: 'भूमिकाएं और अनुमतियां',
    adminLetterhead: 'लेटरहेड और ब्रांडिंग',
    adminIntegrations: 'एसएमएस और व्हाट्सएप',
    adminAiConfig: 'एआई विन्यास',
    adminNavigation: 'मेनू अनुकूलन',
    adminAudit: 'ऑडिट लॉग',
    documentationGroup: 'सहायता और दस्तावेज़',
    societySupportDesk: 'सहायता और समर्थन',
    docsKnowledgeBase: 'ज्ञान केंद्र',
    docsRoleMatrix: 'भूमिका और अनुमति मैट्रिक्स',
    docsQaHub: 'क्यूए टेस्ट हब',
    docsTestExplorer: 'टेस्ट केस एक्सप्लोरर',
    licenseLocked: 'लाइसेंस',
    platformSocietiesGroup: 'सोसायटी और किरायेदार',
    platformSocieties: 'सभी सोसायटियां',
    platformSocietiesNew: 'सोसायटी पंजीकृत करें',
    platformSocietyTypes: 'सोसायटी प्रकार और वर्गीकरण',
    platformTrials: 'निःशुल्क परीक्षण',
    platformSubscriptions: 'सदस्यताएं',
    platformLicenses: 'सॉफ्टवेयर लाइसेंस',
    platformPlans: 'सदस्यता योजनाएं',
    platformInvoices: 'बिलिंग और चालान',
    platformPricingOverrides: 'मूल्य निर्धारण ओवरराइड',
    platformCoupons: 'कूपन और छूट',
    platformPromotionGroup: 'वृद्धि और प्रचार',
    platformPromotionDashboard: 'ग्रोथ डैशबोर्ड',
    platformPromotionProspects: 'संभावनाएं और लीड्स',
    platformPromotionCampaigns: 'अभियान',
    platformPromotionTemplates: 'संदेश टेम्पलेट',
    platformPromotionSenderProfiles: 'प्रेषक प्रोफ़ाइल',
    platformPromotionEmail: 'ईमेल मार्केटिंग',
    platformPromotionWhatsapp: 'व्हाट्सएप प्रसारण',
    platformPromotionSms: 'एसएमएस मार्केटिंग',
    platformPromotionOther: 'अन्य चैनल',
    platformReferrals: 'सहबद्ध और रेफरल',
    platformMarketing: 'मार्केटिंग कर्मी',
    platformPromotionAnalytics: 'प्रचार विश्लेषण',
    platformPromotionSettings: 'मार्केटिंग सेटिंग्स',
    platformManagementGroup: 'प्लेटफ़ॉर्म और समर्थन',
    platformWebsite: 'वेबसाइट सीएमएस और ब्रांडिंग',
    platformSupportTickets: 'समर्थन टिकट डेस्क',
    platformFeatureRequests: 'सुविधा अनुरोध',
    platformFeatures: 'फ़ीचर फ़्लैग',
    platformUsers: 'प्लेटफ़ॉर्म प्रशासक',
    platformCoverageAudit: 'दस्तावेज़ कवरेज ऑडिट',
    platformReportsGroup: 'विश्लेषण और रिपोर्ट',
    platformAnalytics: 'प्लेटफ़ॉर्म विश्लेषण',
    platformSystemGroup: 'सिस्टम और सुरक्षा',
    platformSystemHealth: 'सिस्टम स्वास्थ्य',
    platformAuditLogs: 'ऑडिट लॉग',
    platformNotifications: 'अलर्ट और सूचनाएं',
    platformSettings: 'ग्लोबल सेटिंग्स',
    platformDataCleanup: 'डेटा सफाई',
    platformGoogleCalendar: 'गूगल कैलेंडर एकीकरण',
    platformMaintenance: 'डेटाबेस रखरखाव',
    directory: 'निवासी निर्देशिका',
    members: 'सदस्य',
    houses: 'इकाइयां और फ्लैट',
    settings: 'सेटिंग्स',
    myUnit: 'मेरी इकाई',
    waterTankers: 'पानी के टैंकर',
    patrol: 'गार्ड गश्त',
    cameras: 'लाइव सीसीटीवी',
    marketplace: 'मार्केटप्लेस',
    profile: 'मेरी प्रोफ़ाइल',
    superAdmin: 'प्लेटफ़ॉर्म व्यवस्थापक',
    staff: 'सोसायटी स्टाफ',
    helpDesk: 'हेल्पडेस्क',
    favorites: 'पसंदीदा',
    pinned: 'पिन किए गए',
    navGroupHome: 'होम',
    navGroupSociety: 'मेरी सोसायटी',
    navGroupMoney: 'रुपये व भुगतान',
    navGroupSecurity: 'सुरक्षा व गेट',
    navGroupCommunity: 'समुदाय',
    navGroupManagement: 'प्रबंधन',
    navGroupAdmin: 'प्रशासन',
    navGroupHelp: 'सहायता व दस्तावेज़',
    securityNotificationSettings: 'सुरक्षा नीतियां',
    securityCcCameras: 'सीसीटीवी कैमरे',
  },
  mobile: {
    greetingMorning: 'शुभ प्रभात, {{name}}',
    greetingAfternoon: 'शुभ दोपहर, {{name}}',
    greetingEvening: 'शुभ संध्या, {{name}}',
    greetingNight: 'शुभ रात्रि, {{name}}',
    greetingGeneric: 'स्वागत है, {{name}}',
    priorityAttention: 'ध्यान देने योग्य',
    priorityAllClear: 'सभी बकाया चुकता हैं',
    priorityAllClearSub: 'कोई लंबित मेंटेनेंस या बिल नहीं है',
    payMaintenance: 'मेंटेनेंस भरें',
    payDues: 'अभी भुगतान करें',
    viewDues: 'बकाया देखें',
    viewReceipt: 'रसीद देखें',
    dueBy: 'अंतिम तिथि {{date}}',
    quickActions: 'त्वरित कार्य',
    actionPay: 'बकाया भुगतान',
    actionVisitors: 'आगंतुक',
    actionRaiseIssue: 'समस्या दर्ज करें',
    actionNotices: 'सूचना पट्ट',
    actionBookFacility: 'सुविधा बुक करें',
    actionEmergency: 'आपातकालीन एसओएस',
    actionDirectory: 'डायरेक्टरी',
    actionPolls: 'मतदान व पोल',
    actionMeetings: 'बैठकें',
    societyUpdates: 'सोसायटी अपडेट्स',
    gateAndVisitors: 'गेट व आगंतुक',
    upcomingEvents: 'आगामी कार्यक्रम',
    maintenanceAndReceipts: 'मेंटेनेंस व रसीदें',
    pendingApprovals: 'लंबित स्वीकृतियां',
    collectionsOverview: 'वसूली विवरण',
    pendingReview: 'समीक्षा हेतु लंबित',
    noPendingReviews: 'सभी समीक्षाएं पूर्ण हैं',
    totalCollected: 'कुल प्राप्त राशि',
    totalOutstanding: 'कुल बकाया राशि',
    activeGatePasses: 'सक्रिय गेट पास',
    noVisitorsToday: 'आज कोई आगंतुक नहीं आया',
    noActivePasses: 'कोई सक्रिय आगंतुक पास नहीं है',
    preApproveGuest: 'अतिथि पूर्व-मंजूरी',
    recentReceipts: 'हाल की रसीदें',
    noRecentReceipts: 'कोई हालिया लेनदेन नहीं',
    managementDesk: 'प्रबंधन डेस्क',
    switchRole: 'दृश्य बदलें',
    residentView: 'निवासी दृश्य',
    committeeView: 'समिति दृश्य',
    emergencyModalTitle: 'आपातकालीन एसओएस चेतावनी',
    emergencyModalSubtitle: 'सुरक्षा गार्ड और सोसायटी समिति को तत्काल संकट संकेत भेजें',
    tapToCall: 'गार्ड को कॉल करें',
    tapToWhatsApp: 'कार्यालय व्हाट्सएप',
    pullToRefresh: 'रीफ़्रेश करने के लिए नीचे खींचें',
    refreshing: 'रीफ़्रेश हो रहा है…',
    noMeetingsScheduled: 'कोई बैठक निर्धारित नहीं है',
    noNoticesPublished: 'अभी कोई सूचना प्रकाशित नहीं है',
    noUpcomingEvents: 'कोई आगामी कार्यक्रम नहीं है',
    viewAllNotices: 'सभी सूचनाएं देखें',
    viewAllEvents: 'सभी कार्यक्रम देखें',
    viewAllComplaints: 'सभी शिकायतें देखें',
    sectionDiscover: 'खोजें',
    sectionEngage: 'जुड़ें',
    sectionPay: 'भुगतान',
    cardResidents: 'निवासी',
    cardResidentsDesc: 'अपनी सोसाइटी के लोगों को खोजें',
    cardLocalHelp: 'स्थानीय सहायता',
    cardLocalHelpDesc: 'दैनिक घरेलू सहायता प्राप्त करें',
    cardEmergencyContacts: 'आपातकालीन संपर्क',
    cardEmergencyContactsDesc: 'पुलिस, एम्बुलेंस और महत्वपूर्ण नंबर',
    cardHelpDesk: 'सहायता एवं शिकायतें',
    cardHelpDeskDesc: 'समस्या दर्ज करें या सहायता मांगें',
    cardFacilities: 'सुविधाएं',
    cardFacilitiesDesc: 'सोसाइटी की सुविधाएं बुक करें',
    cardNotices: 'सोसाइटी सूचनाएं',
    cardNoticesDesc: 'सोसाइटी से महत्वपूर्ण अपडेट',
    cardCommunity: 'समुदाय',
    cardCommunityDesc: 'मतदान, बैठकें और कार्यक्रम',
    cardDocuments: 'दस्तावेज़',
    cardDocumentsDesc: 'सोसाइटी और व्यक्तिगत दस्तावेज़',
    cardPaymentsDues: 'भुगतान और बकाया',
    cardPaymentsDuesDesc: 'बकाया देखें और भुगतान करें',
    cardUtilities: 'उपयोगिता सेवाएं',
    cardUtilitiesDesc: 'बिजली, पानी और अन्य सुविधाएं',
    actionRequired: 'ध्यान देने योग्य',
    pendingActionSubtitle: '{{count}} मदों पर समिति कार्रवाई लंबित है',
    collectionsStatus: 'वसूली और बकाया',
    uncollectedSocietyDues: '{{count}} लंबित भुगतान',
    collectedThisMonth: 'इस माह प्राप्त राशि',
    viewLedger: 'खाता देखें',
    committeeActions: 'समिति कार्य',
    postNotice: 'सूचना जारी करें',
    postNoticeDesc: 'सोसाइटी को आधिकारिक सूचना भेजें',
    addExpense: 'खर्च दर्ज करें',
    addExpenseDesc: 'सोसाइटी का खर्च जोड़ें',
    scheduleMeeting: 'बैठक तय करें',
    scheduleMeetingDesc: 'समिति बैठक आयोजित करें',
    residentDirectory: 'निवासी निर्देशिका',
    residentDirectoryDesc: 'निवासियों को खोजें और संपर्क करें',
    complaintsOverview: 'शिकायतें और हेल्पडेस्क',
    upcomingMeetingsCount: '{{count}} आगामी बैठकें',
    viewMeetingAgenda: 'बैठक विवरण और एजेंडा देखें',
    resignOfficeTitle: 'इस्तीफा प्रस्तुत करें',
    resignOfficeNotice: 'सोसायटी सदस्यों को औपचारिक इस्तीफा प्रस्तुत करें',
    activeSocietyElections: 'सक्रिय सोसायटी चुनाव',
    votingLiveStatus: 'सदस्यों के लिए मतदान जारी है',
    castYourVotePrompt: 'नामित समिति उम्मीदवारों के लिए अपना वोट डालें',
    recentNotices: 'हाल की सूचनाएं',
    myComplaints: 'मेरी शिकायतें',
    noActiveComplaints: 'कोई सक्रिय शिकायत या टिकट नहीं',
  },
  profile: {
    profileTitle: 'प्रोफ़ाइल और प्राथमिकताएं',
    profileSubtitle: 'अपनी व्यक्तिगत जानकारी, सुरक्षा सेटिंग्स और ऐप भाषा का प्रबंधन करें।',
    basicDetails: 'मूल विवरण',
    firstName: 'पहला नाम',
    lastName: 'अंतिम नाम',
    email: 'ईमेल पता',
    mobile: 'मोबाइल नंबर',
    saveDetails: 'विवरण सहेजें',
    userId: 'उपयोगकर्ता आईडी',
    roles: 'निर्धारित भूमिकाएं',
    tenant: 'सोसायटी / समुदाय',
    securityBiometrics: 'सुरक्षा और बायोमेट्रिक्स',
    securityBiometricsDesc: 'इस डिवाइस पर त्वरित और सुरक्षित अनलॉकिंग के लिए फ़िंगरप्रिंट या फ़ेस आईडी का उपयोग करें।',
    biometricLoginEnabled: 'बायोमेट्रिक लॉगिन सक्रिय है',
    enableBiometricLogin: 'बायोमेट्रिक लॉगिन सक्षम करें',
    notificationPreferences: 'अधिसूचना प्राथमिकताएं',
    notificationPreferencesDesc: 'नियंत्रित करें कि आपको सोसायटी नोटिस और अलर्ट कैसे प्राप्त हों।',
    languagePreferences: 'ऐप की भाषा',
    languagePreferencesDesc: 'अपनी डिफ़ॉल्ट भाषा चुनें। ऐप आपके लिए हमेशा इसी भाषा में खुलेगा।',
    currentLanguage: 'वर्तमान भाषा',
    selectDefaultLanguage: 'डिफ़ॉल्ट भाषा चुनें',
    defaultLanguageNotice: 'आपकी चुनी हुई भाषा सहेज ली गई है और हर बार ऐप खोलने पर लागू होगी।',
    saveLanguage: 'डिफ़ॉल्ट भाषा के रूप में सेट करें',
    languageUpdated: 'भाषा प्राथमिकता सफलतापूर्वक सहेजी गई',
  },
  dashboard: {
    welcomeBack: 'पुनः स्वागत है',
    welcomeBackUser: 'पुनः स्वागत है, {{name}}',
    societyWorkspace: 'आपका सोसायटी कार्यक्षेत्र',
    platformSubtitle: 'व्योरा प्लेटफ़ॉर्म · सोसायटियां और सॉफ्टवेयर लाइसेंस',
    registerSociety: 'सोसायटी पंजीकृत करें',
    registerSocietyHint: 'किरायेदार और अध्यक्ष लॉगिन बनाएं',
    allSocieties: 'सभी सोसायटियां',
    allSocietiesHint: 'सूची और स्थिति',
    softwareLicenses: 'सॉफ्टवेयर लाइसेंस',
    softwareLicensesHint: 'सोसायटी चुनें, फिर लाइसेंस जारी या समीक्षा करें',
    bankBalance: 'बैंक शेष राशि',
    outstandingDues: 'बकाया देय राशि',
    residents: 'निवासी',
    openRequests: 'खुले अनुरोध',
    upcomingMeetings: 'आगामी बैठकें',
    platform: 'प्लेटफ़ॉर्म',
    societies: 'सोसायटियां',
    licenses: 'लाइसेंस',
    noBankAccounts: 'अभी तक कोई बैंक खाता नहीं है',
    allDuesCleared: 'सभी देय राशियां चुकता हैं',
    noOpenComplaints: 'कोई खुली शिकायत नहीं है',
    noMeetingsScheduled: 'कोई बैठक निर्धारित नहीं है',
    overdueAndOpen: '{{overdue}} अतिदेय · {{open}} खुले बिल',
    openBillsCount: '{{count}} खुले बिल',
    openBillsCountSingle: '1 खुला बिल',
    accountsCountThisMonth: '{{count}} खाते · इस माह {{amount}} प्राप्त',
    accountsCountThisMonthSingle: '1 खाता · इस माह {{amount}} प्राप्त',
    residentsAndHouses: '{{residents}} निवासी · {{houses}} मकान',
    residentsOnRecord: '{{count}} रिकॉर्ड पर दर्ज',
    housesCount: '{{count}} मकान',
    pendingReviewOverdue: '{{pending}} समीक्षाधीन · {{overdue}} अतिदेय',
    pendingReview: '{{count}} समीक्षाधीन',
    statManage: 'प्रबंधन',
    statSubscription: 'सदस्यता',
    collectionsCashflow: 'वसूली और नकदी प्रवाह',
    collected: 'प्राप्त राशि',
    outstanding: 'बकाया राशि',
    thisMonthCashflow: 'इस माह · आवक {{credit}} / जावक {{debit}}',
    cashflow: 'नकदी प्रवाह',
    quickActions: 'त्वरित क्रियाएं',
    scheduleMeeting: 'बैठक निर्धारित करें',
    scheduleMeetingHint: 'मालिकों और कैलेंडर को सूचित करें',
    postNotice: 'सूचना प्रकाशित करें',
    postNoticeHint: 'सोसायटी को सूचित करें',
    raiseComplaint: 'शिकायत दर्ज करें',
    raiseComplaintHint: 'सेवा अनुरोध दर्ज करें',
    filePetition: 'याचिका दायर करें',
    filePetitionHint: 'इस्तीफे की मांग या बर्खास्तगी',
    viewProfile: 'प्रोफ़ाइल देखें',
    viewProfileHint: 'खाता और अनुमतियां',
    publicPetitions: 'सार्वजनिक याचिकाएं',
    openPetitions: 'खुली याचिकाएं · सभी सदस्यों के लिए दृश्यमान',
    openBoard: 'बोर्ड खोलें',
    noMeetingsDescription: 'आगामी समिति बैठकें यहां दिखाई देंगी।',
    announcements: 'घोषणाएं',
    noAnnouncements: 'कोई घोषणा नहीं है',
    noAnnouncementsDesc: 'प्रकाशित सूचनाएं यहां दिखाई देंगी।',
    recentActivity: 'हाल की गतिविधि',
    noActivity: 'अभी तक कोई गतिविधि नहीं',
    noActivityDesc: 'सूचनाएं और अपडेट यहां दिखाई देंगे।',
    recentTransactions: 'हाल के लेन-देन',
    visitorActivity: 'आगंतुक गतिविधि',
    visitorsComingSoon: 'आगंतुक जल्द आ रहे हैं',
    visitorsComingSoonDesc: 'आगंतुक मॉड्यूल सक्षम होने पर गेट लॉग यहां दिखाई देंगे।',
    openVisitors: 'आगंतुक खोलें',
    recentNotices: 'हाल की सूचनाएं',
    pendingComplaints: 'लंबित शिकायतें',
    upcomingEvents: 'आगामी कार्यक्रम',
    maintenanceDue: 'रखरखाव बकाया',
    visitorsToday: 'आज के आगंतुक',
    viewAll: 'सभी देखें',
    societyOverview: 'सोसायटी विवरण',
    activeNotices: 'सक्रिय सूचनाएं',
  },
  complaints: {
    title: 'हेल्पडेस्क और शिकायतें',
    createComplaint: 'शिकायत दर्ज करें',
    category: 'श्रेणी',
    priority: 'प्राथमिकता',
    status: 'स्थिति',
    description: 'विवरण',
    raisedBy: 'द्वारा दर्ज',
    assignedTo: 'सौंपा गया',
    resolve: 'हल मार्क करें',
    myComplaints: 'मेरी शिकायतें',
    allComplaints: 'सोसायटी की सभी शिकायतें',
  },
  visitors: {
    title: 'आगंतुक प्रबंधन',
    logVisitor: 'आगंतुक पूर्व-स्वीकृति',
    visitorName: 'आगंतुक का नाम',
    phone: 'फ़ोन नंबर',
    hostUnit: 'फ्लैट / यूनिट',
    purpose: 'आने का उद्देश्य',
    vehicleNumber: 'वाहन संख्या',
    checkIn: 'चेक इन',
    checkOut: 'चेक आउट',
    expectedVisitors: 'अपेक्षित मेहमान',
    activeVisitors: 'वर्तमान में अंदर',
  },
  finance: {
    title: 'वित्त और भुगतान',
    dues: 'बकाया राशि',
    payNow: 'अभी भुगतान करें',
    transactions: 'लेन-देन इतिहास',
    invoices: 'रखरखाव चालान',
    receipts: 'भुगतान रसीदें',
    paymentHistory: 'भुगतान का इतिहास',
    maintenanceFee: 'मासिक रखरखाव शुल्क',
    outstandingBalance: 'कुल बकाया',
    paid: 'भुगतान किया गया',
    unpaid: 'अदत्त',
  },
  notices: {
    title: 'सोसायटी सूचनाएं',
    createNotice: 'सूचना जारी करें',
    important: 'महत्वपूर्ण सूचना',
    publishedOn: 'प्रकाशित दिनांक',
    readMore: 'पूरी सूचना पढ़ें',
    attachments: 'संलग्न दस्तावेज़',
    societyAnnouncements: 'सामुदायिक घोषणाएं',
  },
  amenities: {
    title: 'सोसायटी सुविधाएं',
    bookAmenity: 'सुविधा बुक करें',
    myBookings: 'मेरी बुकिंग्स',
    availableSlots: 'उपलब्ध समय स्लॉट',
    rules: 'नियम और दिशानिर्देश',
  },
  elections: {
    title: 'चुनाव और मतदान',
    activeElections: 'सक्रिय चुनाव',
    castVote: 'अपना वोट डालें',
    candidates: 'नामित उम्मीदवार',
    results: 'चुनाव परिणाम',
  },
  emergency: {
    emergencyAlert: 'आपातकालीन चेतावनी (EMERGENCY)',
    triggerAlert: 'एसओएस अलर्ट भेजें',
    fire: 'आग की आपात स्थिति',
    medical: 'चिकित्सा आपात स्थिति',
    security: 'सुरक्षा खतरा',
    panic: 'पैनिक बटन',
    sos: 'एसओएस प्रसारण',
    activeAlert: 'आपातकालीन अलर्ट सक्रिय है',
  },
  validation: {
    required: 'यह फ़ील्ड आवश्यक है।',
    invalidEmail: 'कृपया एक मान्य ईमेल पता दर्ज करें।',
    invalidMobile: 'कृपया एक मान्य 10-अंकीय मोबाइल नंबर दर्ज करें।',
    passwordTooShort: 'पासवर्ड कम से कम 8 वर्णों का होना चाहिए।',
    positiveNumber: 'कृपया एक सकारात्मक मान दर्ज करें।',
  },
  superAdmin: {
    title: 'प्लेटफ़ॉर्म प्रशासन',
    dashboard: 'डैशबोर्ड',
    platformOverview: 'प्लेटफ़ॉर्म अवलोकन',
    platformOverviewSubtitle: 'वास्तविक समय मल्टी-टेनेंट सोसायटी मेट्रिक्स, सदस्यता स्थिति, और प्लेटफ़ॉर्म गतिविधि',
    totalSocieties: 'कुल सोसायटियां',
    societiesActiveAndTrial: '{{active}} सक्रिय · {{trial}} परीक्षण में',
    monthlyRecurring: 'मासिक आवर्ती राजस्व (MRR)',
    annualRecurring: 'वार्षिक ARR: {{arr}}',
    activeTrials: 'सक्रिय परीक्षण',
    expiringInDays: '30 दिनों में {{count}} समाप्त हो रहे हैं',
    totalPlatformUsers: 'कुल प्लेटफ़ॉर्म उपयोगकर्ता',
    acrossAllManagedSocieties: 'सभी प्रबंधित सोसायटियों में',
    upcomingExpirations: 'आगामी परीक्षण और लाइसेंस समाप्ति (अगले 30 दिन)',
    upcomingExpirationsSubtitle: 'परीक्षण विस्तार, नवीनीकरण या रूपांतरण की आवश्यकता वाली सोसायटियां',
    noUpcomingExpirations: 'अगले 30 दिनों में कोई आगामी लाइसेंस समाप्ति नहीं है।',
    societyName: 'सोसायटी का नाम',
    plan: 'योजना',
    expiresIn: 'समाप्ति में समय',
    manage: 'प्रबंधन',
    subscriptionTierShare: 'सदस्यता योजना हिस्सेदारी',
    subscriptionTierShareSubtitle: 'योजनाओं के अनुसार सक्रिय सोसायटी वितरण',
    noPlanDistribution: 'कोई योजना वितरण डेटा उपलब्ध नहीं है',
    daysCount: '{{count}} दिन',
    expiredToday: 'आज समाप्त हो गया',
    freeTrial: 'निःशुल्क परीक्षण',
    analytics: 'प्लेटफ़ॉर्म एनालिटिक्स',
    societies: 'सभी सोसायटियां',
    societyTypes: 'सोसायटी प्रकार',
    trials: 'निःशुल्क परीक्षण और ऑनबोर्डिंग',
    subscriptions: 'सदस्यताएं',
    licenses: 'सॉफ्टवेयर लाइसेंस',
    plans: 'सदस्यता योजनाएं',
    invoices: 'बिलिंग और चालान',
    pricingOverrides: 'मूल्य निर्धारण अधिलेखन',
    coupons: 'कूपन और छूट',
    promotion: 'विकास और प्रचार',
    referrals: 'सहयोगी और रेफरल',
    marketing: 'विपणन कर्मी',
    websiteCms: 'वेबसाइट सीएमएस और ब्रांडिंग',
    features: 'सुविधा झंडे',
    platformUsers: 'प्लेटफ़ॉर्म प्रशासक',
    systemHealth: 'सिस्टम स्वास्थ्य',
    auditLogs: 'ऑडिट लॉग',
    settings: 'वैश्विक सेटिंग्स',
    dataCleanup: 'डेटा सफ़ाई',
    maintenance: 'डेटाबेस रखरखाव',
  },
  tables: {
    noRecords: 'मापदंड से मेल खाने वाले कोई रिकॉर्ड नहीं मिले',
    rowsPerPage: 'पंक्तियाँ प्रति पृष्ठ:',
    pageOf: 'पृष्ठ {{page}} का {{totalPages}}',
    filterResults: 'परिणाम फ़िल्टर करें...',
    showingResults: 'कुल {{count}} परिणाम दिखाए जा रहे हैं',
  },
  dialogs: {
    confirmAction: 'कार्रवाई की पुष्टि करें',
    confirmDelete: 'हटाने की पुष्टि करें',
    areYouSure: 'क्या आप वाकई आगे बढ़ना चाहते हैं?',
    irreversibleNotice: 'यह कार्रवाई पूर्ववत नहीं की जा सकती।',
    discardChanges: 'बिना सहेजे गए परिवर्तन त्यागें?',
  },
  feedback: {
    savedSuccess: 'विवरण सफलतापूर्वक सहेजा गया',
    updateSuccess: 'सफलतापूर्वक अपडेट किया गया',
    errorOccurred: 'एक त्रुटि हुई। कृपया पुनः प्रयास करें।',
    languageChanged: 'भाषा हिन्दी में बदल दी गई है',
    biometricEnabledSuccess: 'बायोमेट्रिक प्रमाणीकरण सक्षम किया गया',
    biometricDisabledSuccess: 'बायोमेट्रिक प्रमाणीकरण अक्षम किया गया',
  },
};
